import { onlyUnique } from "../../../utils";
import { KPIFillMode } from "../Edit/KPIEditParamList";

export function produceScheduleRule(
  selectedDays: number[],
  fillMode: KPIFillMode,
  taskId: string
) {
  const uniqueDays = selectedDays.filter(onlyUnique);
  const isWeekly = uniqueDays.length === 1 && uniqueDays[0] === 0;

  return {
    freq: isWeekly ? ("WEEKLY" as const) : ("DAILY" as const),
    tasks: [{ importance: "REQUIRED" as const, taskId }],
    byhour: fillMode === "previous" ? [23] : [0],
    byminute: fillMode === "previous" ? [59] : [0],
    bysecond: [0],
    byweekday: isWeekly
      ? fillMode === "previous"
        ? [6]
        : [0]
      : uniqueDays.length === 7 || uniqueDays.length === 0
        ? undefined
        : uniqueDays,
  };
}

export function parseFillMode(
  byhour: readonly (number | null | undefined)[] | null | undefined,
  bymin: readonly (number | null | undefined)[] | null | undefined
): KPIFillMode {
  const hourIsPrev = byhour?.length === 1 && byhour[0] === 23;
  const minIsPrev = bymin?.length === 1 && bymin[0] === 59;
  return hourIsPrev && minIsPrev ? "previous" : "current";
}
